const NETWORK_ACTIVITY = 'dailymile/auth/NETWORK_ACTIVITY';

let _httpCount = 0;

function onThread(callback) {
  // TODO: should this be requestAnimationFrame?
  global.setTimeout(callback, 0);
}

export default function reducer(state = {}, action = {}) {
  return state;
}

export const startedNetworkRequest = () => {
  onThread(function() {
    if (_httpCount < 0) _httpCount = 0;
    _httpCount++;
    if (_httpCount === 1) {
      return {
        type: NETWORK_ACTIVITY,
        payload: {
          isActive: true
        }
      };
    }
  });
}

export const completedNetworkRequest = () => {
  onThread(function() {
    _httpCount--;
      if (_httpCount < 0) _httpCount = 0;
      if (_httpCount === 0) {
        return {
          type: NETWORK_ACTIVITY,
          payload: {
            isActive: false
          }
        };
      }
  });
}


// WEBPACK FOOTER //
// ./src/redux/modules/network.js